import "../styles/dashboard.css";
import { useEffect, useState, useRef } from "react";
import Button from "../components/Button";
import Select from "react-select";
import api from "../api/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
 
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
} from "recharts";
 
const Intelligence = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [activeTab, setActiveTab] = useState("harvest");
 
  const [harvestVsFarmer, setHarvestVsFarmer] = useState([]);
  const [harvestVsCrop, setHarvestVsCrop] = useState([]);
  const [salesVsCrop, setSalesVsCrop] = useState([]);
  const [priceVsCrop, setPriceVsCrop] = useState([]);
  const [salesVsBuyer, setSalesVsBuyer] = useState([]);
  const [cropVsQuantity, setCropVsQuantity] = useState([]);
  const [buyerVsQuantity, setBuyerVsQuantity] = useState([]);
  const [inputSpendBreakdown, setInputSpendBreakdown] = useState([]);
  const [inputEfficiency, setInputEfficiency] = useState([]);
  const [inventoryIntelligence, setInventoryIntelligence] = useState([]);
  const [inventoryStatusFilter, setInventoryStatusFilter] = useState("All");
 
 
 
 
  // Static business data
  // const data = [
  //   { crop: "Wheat", sold: 600, remaining: 400 },
  //   { crop: "Corn", sold: 500, remaining: 300 },
  //   { crop: "Rice", sold: 900, remaining: 300 },
// ];

  const CHART_HEIGHT = 300;
 
  const formatNumber = (num) => {
    if (num >= 1e12) return (num / 1e12).toFixed(1) + "T";
    if (num >= 1e9) return (num / 1e9).toFixed(1) + "B";
    if (num >= 1e6) return (num / 1e6).toFixed(1) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1) + "K";
    return num;
  };
 
  const fetchCategories = async () => {
    try {
      const res = await api.get("/categories");
      const formatted = res.data.categories.map((cat) => ({
        value: cat.id,
        label: cat.category_name,
      }));
      setCategories(formatted);
    } catch (error) {
      console.error("Category fetch error:", error);
    }
  };
 
  const fetchHarvestVsFarmer = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/harvest-vs-farmer", { params });
      setHarvestVsFarmer(res.data.data);
    } catch (error) {
      console.error("Harvest vs Farmer Error:", error);
    }
  };
 
  const fetchHarvestVsCrop = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/harvest-vs-crop", { params });
      setHarvestVsCrop(res.data.data);
    } catch (error) {
      console.error("Harvest vs Crop Error:", error);
    }
  };
 
  const fetchSalesVsCrop = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/sales-vs-crop", { params });
      setSalesVsCrop(res.data.data);
    } catch (error) {
      console.error("Sales vs Crop Error:", error);
    }
  };
 
  const fetchPriceVsCrop = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/price-vs-crop", { params });
      setPriceVsCrop(res.data.data);
    } catch (error) {
      console.error("Price vs Crop Error:", error);
    }
  };
 
const fetchSalesVsBuyer = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/sales-vs-buyer", { params });
      setSalesVsBuyer(res.data.data);
    } catch (error) {
      console.error("Sales vs Buyer Error:", error);
    }
  };

  const fetchCropVsQuantity = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/sales-vs-crop-quantity", { params });
      setCropVsQuantity(res.data.data);
    } catch (error) {
      console.error("Crops vs Quantity Error:", error);
    }
  };

  const fetchBuyerVsQuantity = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/sales-vs-buyer-quantity", { params });
      setBuyerVsQuantity(res.data.data);
    } catch (error) {
      console.error("Buyer vs Quantity Error:", error);
    }
  };

  const fetchInputSpendBreakdown = async (start, end) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      const res = await api.get("/intelligence/input-spend-breakdown", { params });
      setInputSpendBreakdown(res.data.data);
    } catch (error) {
      console.error("Input Spend Breakdown Error:", error);
    }
  };
 
  const fetchInputEfficiency = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/input-efficiency", { params });
      
      // Transform data for single bar display
const transformed = res.data.data.map(item => {
      const inputCost = item.input_cost;
      const avgYield = item.avg_yield;
      
      if (avgYield < inputCost) {
        return {
          crop: item.crop,
          bottom: avgYield,
          top: inputCost - avgYield,
          input_cost: inputCost,
          avg_yield: avgYield
        };
      } else {
        return {
          crop: item.crop,
          bottom: inputCost,
          top: avgYield - inputCost,
          input_cost: inputCost,
          avg_yield: avgYield
        };
      }
    });
setInputEfficiency(transformed);
    } catch (error) {
      console.error("Input Efficiency Error:", error);
    }
  };

  const fetchInventoryIntelligence = async (start, end, categoryId) => {
    try {
      const params = {};
      if (start) params.startDate = start.toISOString();
      if (end) params.endDate = end.toISOString();
      if (categoryId) params.categoryId = categoryId;
      const res = await api.get("/intelligence/inventory-intelligence", { params });
      setInventoryIntelligence(res.data.data);
    } catch (error) {
      console.error("Inventory Intelligence Error:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchAllData();
  }, []);
 
  const fetchAllData = (start, end, categoryId) => {
    fetchHarvestVsFarmer(start, end, categoryId);
    fetchHarvestVsCrop(start, end, categoryId);
    fetchSalesVsCrop(start, end, categoryId);
    fetchPriceVsCrop(start, end, categoryId);
    fetchSalesVsBuyer(start, end, categoryId);
    fetchCropVsQuantity(start, end, categoryId);
    fetchBuyerVsQuantity(start, end, categoryId);
    fetchInputSpendBreakdown(start, end);
    fetchInputEfficiency(start, end, categoryId);
    fetchInventoryIntelligence(start, end, categoryId);
  };
 
  const handleFilter = () => {
    const start = startDate;
    const end = endDate;
    const categoryId = selectedCategory ? selectedCategory.value : null;
    fetchAllData(start, end, categoryId);
    setOpen(false);
  };
 
  const handleClearFilter = () => {
    setDateRange([null, null]);
    setSelectedCategory(null);
    fetchAllData(null, null, null);
    setOpen(false);
  };
 
  const handleToggle = () => {
    setOpen((prev) => !prev);
  };
 
 
 
 
  return (
    <>
      <div className="row align-items-center mb-4">
        <div className="col-sm-6 col-md-3">
          <input
            ref={inputRef}
            readOnly
            value={
              startDate && endDate
                ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                : ""
            }
            onClick={handleToggle}
            placeholder="Select Date Range"
            className="form-control"
          />
          {open && (
            <div className="position-absolute bg-white shadow p-3 rounded mt-1 z-3">
              <DatePicker
                inline
                selectsRange
                monthsShown={2}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                maxDate={new Date()}
              />
              <div className="d-flex justify-content-end mt-2">
                <Button onClick={handleToggle} text="Done" btncls="me-2" />
                <Button
                  onClick={handleClearFilter}
                  text="Clear"
                  variant="danger"
                />
              </div>
            </div>
          )}
        </div>
        <div className="col-sm-6 col-md-3 mt-3 mt-sm-0">
          <Select
            options={categories}
            value={selectedCategory}
            onChange={(option) => setSelectedCategory(option)}
            placeholder="Select Category"
            isClearable
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-5 col-xl-3 d-flex mt-3 mt-sm-0">
          <Button
            onClick={handleFilter}
            text="Apply Filter"
            btncls="me-2 mt-0 w-100 w-sm-auto"
          />
          <Button
            onClick={handleClearFilter}
            text="Clear Filter"
            variant="secondary"
            btncls="mt-0 bg-secondary w-100"
          />
        </div>
        <div className="col-12 mt-3">
          <div className="d-flex gap-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="intelligenceTab"
                id="harvestTab"
                checked={activeTab === "harvest"}
                onChange={() => setActiveTab("harvest")}
              />
              <label className="form-check-label" htmlFor="harvestTab">
                Harvest Intelligence
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="intelligenceTab"
                id="salesTab"
                checked={activeTab === "sales"}
                onChange={() => setActiveTab("sales")}
              />
              <label className="form-check-label" htmlFor="salesTab">
                Sales Intelligence
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="intelligenceTab"
                id="farmInputTab"
                checked={activeTab === "farmInput"}
                onChange={() => setActiveTab("farmInput")}
              />
              <label className="form-check-label" htmlFor="farmInputTab">
                Farm Input Purchase
              </label>
</div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="intelligenceTab"
                id="inventoryTab"
                checked={activeTab === "inventory"}
                onChange={() => setActiveTab("inventory")}
              />
              <label className="form-check-label" htmlFor="inventoryTab">
                Inventory Intelligence
              </label>
            </div>
  

    
          </div>
        </div>
      </div>
 
      <div className="dashboard-container">
        {activeTab === "harvest" && (
          <>
            {/* <h2 className="section-header">Harvest Intelligence</h2> */}
            <div className="dashboard-widgets mb-5">
              <div className="widget">
                 <div className="d-flex align-items-center justify-content-between">
                <h2 className="h22">Harvest vs Farmer</h2>
                    <div
                    style={{
                      fontSize: "14px",
                    }}
                    className="d-flex align-items-center g-2"
                  >
                    <span
                      style={{
                        backgroundColor: "#4CAF50",
                        width: "12px",
                        height: "12px",
                        borderRadius: "2px",
                      }}
                    ></span>
                    <span className="ms-2">Harvest</span>
                  </div>
                  </div>
                <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
                  <BarChart data={harvestVsFarmer}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="farmer" />
                    <YAxis tickFormatter={formatNumber} />
                    <Tooltip formatter={(val) => formatNumber(val)} />
                    {/* <Legend /> */}
                    <Bar dataKey="totalHarvest" fill="#4CAF50" name="Harvest" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="widget">
                     <div className="d-flex align-items-center justify-content-between">
                  <h2 className="h22">Harvest vs Crops</h2>
 
                  <div
                    style={{
                      fontSize: "14px",
                    }}
                    className="d-flex align-items-center g-2"
                  >
                    <span
                      style={{
                        backgroundColor: "#2196F3",
                        width: "12px",
                        height: "12px",
                        borderRadius: "2px",
                      }}
                    ></span>
                    <span className="ms-2">Harvest</span>
                  </div>
</div>
 
 
 
 
               
                <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
                  <BarChart data={harvestVsCrop}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="crop" />
                    <YAxis tickFormatter={formatNumber} />
                    <Tooltip formatter={(val) => formatNumber(val)} />
                    {/* <Legend /> */}
                    <Bar dataKey="totalHarvest" fill="#2196F3" name="Harvest" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </>
        )}
 
        {activeTab === "sales" && (
          <>
            {/* <h2 className="section-header">Sales Intelligence</h2> */}
            <div className="dashboard-widgets">
              <div className="widget">
                 <div className="d-flex align-items-center justify-content-between">
                  <h2 className="h22">Sales vs Crop</h2>
 
                  <div
                    style={{
                      fontSize: "14px",
                    }}
                    className="d-flex align-items-center g-2"
                  >
                    <span
                      style={{
                        backgroundColor: "#FF9800",
                        width: "12px",
                        height: "12px",
                        borderRadius: "2px",
                      }}
                    ></span>
                    <span className="ms-2">Sales</span>
                  </div>
                </div>
                <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
                  <BarChart data={salesVsCrop}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="crop" />
                    <YAxis tickFormatter={formatNumber} />
                    <Tooltip formatter={(val) => `₹${formatNumber(val)}`} />
                    {/* <Legend /> */}
                    <Bar dataKey="totalSales" fill="#FF9800" name="Sales" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="widget">
                <div className="d-flex align-items-center justify-content-between">
                  <h2 className="h22">Price (per kg) vs Crop</h2>
 
                  <div
                    style={{
                      fontSize: "14px",
                    }}
                    className="d-flex align-items-center g-2"
                  >
                    <span
                      style={{
                        backgroundColor: "#9C27B0",
                        width: "12px",
                        height: "12px",
                        borderRadius: "2px",
                      }}
                    ></span>
                    <span className="ms-2">Avg Price (₹)</span>
                  </div>
                </div>
 
 
 
 
 
                <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
                  <BarChart data={priceVsCrop}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="crop" />
                    <YAxis tickFormatter={formatNumber} />
                    <Tooltip formatter={(val) => `₹${formatNumber(val)}`} />
                    {/* <Legend /> */}
                    <Bar dataKey="avgPrice" fill="#9C27B0" name="Avg Price (₹)" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="widget">
                     <div className="d-flex align-items-center justify-content-between">
                  <h2 className="h22">Sales vs Buyer</h2>
 
                  <div
                    style={{
                      fontSize: "14px",
                    }}
                    className="d-flex align-items-center g-2"
                  >
                    <span
                      style={{
                        backgroundColor: "#E91E63",
                        width: "12px",
                        height: "12px",
                        borderRadius: "2px",
                      }}
                    ></span>
                    <span className="ms-2">Sales</span>
                  </div>
                </div>
                <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
                  <BarChart data={salesVsBuyer}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="buyer" />
                    <YAxis tickFormatter={formatNumber} />
                    <Tooltip formatter={(val) => `₹${formatNumber(val)}`} />
                    {/* <Legend /> */}
                    <Bar dataKey="totalSales" fill="#E91E63" name="Sales" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
 
 
             
           
 
            <div className="widget">
  <div className="d-flex align-items-center justify-content-between">
    <h2 className="h22">Crops vs Quantity</h2>
 
    <div
      style={{ fontSize: "14px" }}
      className="d-flex align-items-center g-2"
    >
      <span
        style={{
          backgroundColor: "#3F51B5",
          width: "12px",
          height: "12px",
          borderRadius: "2px",
        }}
      ></span>
      <span className="ms-2">Quantity (kg)</span>
    </div>
  </div>
 
  <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
    <BarChart data={cropVsQuantity}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="crop" />
      <YAxis tickFormatter={formatNumber} />
      <Tooltip formatter={(val) => `${formatNumber(val)} kg`} />
      <Bar dataKey="quantity" fill="#3F51B5" name="Quantity" />
    </BarChart>
  </ResponsiveContainer>
</div>
 
 
 
 
 
 
<div className="widget">
  <div className="d-flex align-items-center justify-content-between">
    <h2 className="h22">Buyer vs Quantity</h2>
 
    <div className="d-flex align-items-center g-2" style={{ fontSize: "14px" }}>
      <span
        style={{
          backgroundColor: "#4CAF50",
          width: "12px",
          height: "12px",
          borderRadius: "2px",
        }}
      ></span>
      <span className="ms-2">Quantity</span>
    </div>
  </div>
 
  <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
    <BarChart data={buyerVsQuantity}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="buyer" />
      <YAxis tickFormatter={formatNumber} />
      <Tooltip formatter={(val) => `${formatNumber(val)} kg`} />
      <Bar dataKey="quantity" fill="#4CAF50" />
    </BarChart>
  </ResponsiveContainer>
</div>
 
 
 
 </div>
          </>
        )}
 
        {activeTab === "farmInput" && (
          <>
            <div className="dashboard-widgets">
              <div className="widget">
                <h2 className="h22">Input Spend Breakdown</h2>
                <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
                  <PieChart>
                    <Pie
                      data={inputSpendBreakdown}
                      dataKey="total_spend"
                      nameKey="input_type"
                      cx="50%"
                      cy="50%"
                      outerRadius={100}
                      label={({ name, percent }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {inputSpendBreakdown.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={[
                            "#4CAF50",
                            "#2196F3",
                            "#FF9800",
                            "#9C27B0",
                            "#E91E63",
                          ][index % 5]}
                        />
                      ))}
                    </Pie>
                    <Tooltip formatter={(val) => `₹${formatNumber(val)}`} />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="widget">
                <h2 className="h22">Input Cost vs Yield</h2>
                <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
                  <BarChart data={inputEfficiency}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="crop" />
                    <YAxis tickFormatter={formatNumber} />
<Tooltip 
                      formatter={(val, name, props) => {
                        const item = inputEfficiency.find(i => i.crop === props?.payload?.crop);
                        if (name === "Input Cost (₹)" && item?.input_cost !== undefined && item?.input_cost !== null) {
                          return [`₹${formatNumber(item.input_cost)}`, name];
                        }
                        if (name === "Avg Yield (₹)" && item?.avg_yield !== undefined && item?.avg_yield !== null) {
                          return [`₹${formatNumber(item.avg_yield)}`, name];
                        }
                        return [`₹${formatNumber(val)}`, name];
                      }}
                    />
                    <Legend />
                    <Bar
                      dataKey="bottom"
                      fill="#FFC107"
                      name="Input Cost (₹)"
                      stackId="stack"
                    />
                    <Bar
                      dataKey="top"
                      fill="#4CAF50"
                      name="Avg Yield (₹)"
                      stackId="stack"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
</div>
          </>
        )}

        {activeTab === "inventory" && (
          <>
            <div style={{ display: "flex", gap: "20px", marginBottom: "20px", flexWrap: "wrap" }}>
              <div
                onClick={() => setInventoryStatusFilter(inventoryStatusFilter === "Understock" ? "All" : "Understock")}
                style={{
                  flex: 1,
                  padding: "20px",
                  background: inventoryStatusFilter === "Understock" ? "#FFCDD2" : "#fff",
                  border: "2px solid #F44336",
                  borderRadius: "8px",
                  cursor: "pointer",
                  textAlign: "center",
                  minWidth: "150px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}
              >
                <h3 style={{ color: "#F44336", margin: 0 }}>{inventoryIntelligence.filter(i => i.status === "Understock").length}</h3>
                <p style={{ margin: "5px 0 0 0", color: "#333" }}>Understock</p>
              </div>
              <div
                onClick={() => setInventoryStatusFilter(inventoryStatusFilter === "Balanced" ? "All" : "Balanced")}
                style={{
                  flex: 1,
                  padding: "20px",
                  background: inventoryStatusFilter === "Balanced" ? "#C8E6C9" : "#fff",
                  border: "2px solid #4CAF50",
                  borderRadius: "8px",
                  cursor: "pointer",
                  textAlign: "center",
                  minWidth: "150px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}
              >
                <h3 style={{ color: "#4CAF50", margin: 0 }}>{inventoryIntelligence.filter(i => i.status === "Balanced").length}</h3>
                <p style={{ margin: "5px 0 0 0", color: "#333" }}>Balanced</p>
              </div>
              <div
                onClick={() => setInventoryStatusFilter(inventoryStatusFilter === "Overstock" ? "All" : "Overstock")}
                style={{
                  flex: 1,
                  padding: "20px",
                  background: inventoryStatusFilter === "Overstock" ? "#FFE0B2" : "#fff",
                  border: "2px solid #FF9800",
                  borderRadius: "8px",
                  cursor: "pointer",
                  textAlign: "center",
                  minWidth: "150px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}
              >
                <h3 style={{ color: "#FF9800", margin: 0 }}>{inventoryIntelligence.filter(i => i.status === "Overstock").length}</h3>
                <p style={{ margin: "5px 0 0 0", color: "#333" }}>Overstock</p>
              </div>
            </div>

            <div style={{ overflowX: "auto", maxHeight: "350px", overflowY: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                <thead>
                  <tr style={{ background: "#f5f5f5", position: "sticky", top: 0, zIndex: 1 }}>
                    <th style={{ padding: "12px", textAlign: "left", borderBottom: "2px solid #ddd" }}>Product</th>
                    <th style={{ padding: "12px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Harvest (kg)</th>
                    <th style={{ padding: "12px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Sales (kg)</th>
                    <th style={{ padding: "12px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Inventory (kg)</th>
                    <th style={{ padding: "12px", textAlign: "right", borderBottom: "2px solid #ddd" }}>Daily Rate (kg/day)</th>
                    <th style={{ padding: "12px", textAlign: "right", borderBottom: "2px solid #ddd" }}>DOI (days)</th>
                    <th style={{ padding: "12px", textAlign: "center", borderBottom: "2px solid #ddd" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {inventoryIntelligence
                    .filter(item => inventoryStatusFilter === "All" || item.status === inventoryStatusFilter)
                    .map((item, index) => (
                      <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                        <td style={{ padding: "12px" }}>{item.product}</td>
                        <td style={{ padding: "12px", textAlign: "right" }}>{item.total_harvest}</td>
                        <td style={{ padding: "12px", textAlign: "right" }}>{item.total_sales}</td>
                        <td style={{ padding: "12px", textAlign: "right" }}>{item.current_inventory}</td>
                        <td style={{ padding: "12px", textAlign: "right" }}>{item.daily_sales_rate}</td>
                        <td style={{ padding: "12px", textAlign: "right" }}>{item.doi !== null ? item.doi : "N/A"}</td>
                        <td style={{ padding: "12px", textAlign: "center" }}>
                          <span style={{
                            padding: "4px 12px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            background: item.status === "Understock" ? "#F44336" : item.status === "Overstock" ? "#FF9800" : "#4CAF50",
                            color: "#fff"
                          }}>
                            {item.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}

      </div>
    </>
  );
};

export default Intelligence;